// ********* CardCAgendamentos - agendamentos.jsx ********
// autor: W de Paula / MVinfo
// data: 06/6/24 | 17h50
// **************************************************


import './agendamentos.css';

function CardCAgendamentos({agendamento, showExcluir, showAvaliar, showMotivo, handleAvaliar, handleExcluir, handleMotivo }) {
// function CardCAgendamentos(props) {
    const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <tr key={agendamento.agendamento_id}>
            <td data-label="Id.Reserva">{agendamento.agendamento_id}</td>
            <td data-label="Descrição">{agendamento.agendamento_descricao}</td>
            <td data-label="Nome Empresa">{agendamento.agendamento_nome}</td>
            <td data-label="Endereço:">{agendamento.agendamento_endereco}</td>
            {/* <td data-label="Fone:">{agendamento.agendamento_fone}</td> */}
            {/* <td data-label={ agendamento.agendamento_fone ? "Fone:" : "" }>
                { agendamento.agendamento_fone ? agendamento.agendamento_fone : 'N/A' }
            </td> */}
            <td data-label="Fone:">
                { agendamento.agendamento_fone ? agendamento.agendamento_fone : 'N/A' }
            </td>
            <td data-label="Data:">{agendamento.agendamento_data}</td>
            <td data-label="Hora:">{agendamento.agendamento_hora}h</td>
            <td data-label="Valor:">
                {agendamento.agendamento_vr === 0 ? 'N/A' : formatCurrency(agendamento.agendamento_vr)}
            </td>
            <td data-label="Status:" className="text-right">{agendamento.agendamento_status}</td>
            { (showAvaliar || showMotivo || showExcluir) && (
                <td data-label="Ações:">
                    {showAvaliar && (
                        <button className="btn btn-info ml-2" onClick={() => handleAvaliar(agendamento)}>
                            <i className="bi bi-star-half"></i> Avaliar
                        </button>
                    )}
                    {showMotivo && (
                        <button className="btn btn-warning ml-2" onClick={() => handleMotivo(agendamento)}>
                            <i className="bi bi-x-circle"></i> Motivo
                        </button>
                    )}
                    {showExcluir && (
                        <button className="btn btn-danger ml-2" onClick={() => handleExcluir(agendamento)}>
                            <i className="bi bi-trash-fill"></i> Excluir
                        </button>
                    )}
                    
                </td>
            )}
        </tr>
    );
}

export default CardCAgendamentos;




// // import Swal from 'sweetalert2';
// // import { Link } from 'react-router-dom';

// // import './agendamentos.css';

// // function CardCAgendamentos(props){

// //     const formatCurrency = (value) => {
// //         return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
// //     };

// //     // const imgSrc = `data:image/png;base64,${props.categoria_icone}`; // Certifique-se de que o tipo de imagem está correto (não é aspas simples e sim crases ``)
// //     // const handleClick = () => {
// //     //     localStorage.setItem("id_categoria", props.categoria_id);
// //     // };

// //     return (
// //         <tr key={props.agendamento_id}>
// //             <td data-label="Id.Reserva">{props.agendamento_id}</td>
// //             <td data-label="Descrição">{props.agendamento_descricao}</td>
// //             <td data-label="Nome Empresa">{props.agendamento_nome}</td>
// //             <td data-label="Endereço:">{props.agendamento_endereco}</td>
// //             <td data-label="Fone:">{props.agendamento_fone}</td>
// //             <td data-label="Data:">{props.agendamento_data}</td>
// //             <td data-label="Hora:">{props.agendamento_hora}h</td>
// //             <td data-label="Valor:">
// //             {props.agendamento_vr === 0 ? (
// //                     'N/A'
// //                 ) : (
// //                     formatCurrency(props.agendamento_vr)
// //                 )}
// //             </td>
// //             <td data-label="Status:" className="text-right">{props.agendamento_status}</td>
// //             <td data-label="Ações">
// //                 {/* {dados.USU_TIPO_AGENDA !== null && dados.USU_TIPO_AGENDA !== undefined ? setTipoAgenda(dados.USU_TIPO_AGENDA) : setTipoAgenda(0)} */}
// //                 <button
// //                         // className="btn btn-info ml-10"
// //                         className="btn btn-info ml-2"
// //                         // onClick={() => 
// //                         //     CarregaEmpresa(
// //                         //     dados.ID_EMPRESA,
// //                         //     dados.NOME,
// //                         //     `${dados.ENDERECO} - ${dados.BAIRRO} - ${dados.CIDADE}`,
// //                         //     dados.FONE,
// //                         //     // dados.USU_TIPO_AGENDA // ou a variável que contém o tipo de agenda
// //                         //     // tipoAgenda // ou a variável que contém o tipo de agenda
// //                         //     dados.USU_TIPO_AGENDA 
// //                         //         !== null && dados.USU_TIPO_AGENDA 
// //                         //         !== undefined 
// //                         //             ? dados.USU_TIPO_AGENDA
// //                         //             : 0
// //                         // )}
// //                     >
// //                         <i className="bi bi-star-half"></i>
// //                         Avaliar
// //                 </button>
// //                 <button
// //                         // className="btn btn-info ml-10"
// //                         className="btn btn-warning ml-2"
// //                         // onClick={() => 
// //                         //     CarregaEmpresa(
// //                         //     dados.ID_EMPRESA,
// //                         //     dados.NOME,
// //                         //     `${dados.ENDERECO} - ${dados.BAIRRO} - ${dados.CIDADE}`,
// //                         //     dados.FONE,
// //                         //     // dados.USU_TIPO_AGENDA // ou a variável que contém o tipo de agenda
// //                         //     // tipoAgenda // ou a variável que contém o tipo de agenda
// //                         //     dados.USU_TIPO_AGENDA 
// //                         //         !== null && dados.USU_TIPO_AGENDA 
// //                         //         !== undefined 
// //                         //             ? dados.USU_TIPO_AGENDA
// //                         //             : 0
// //                         // )}
// //                     >
// //                         <i className="bi bi-x-circle"></i>
// //                         Motivo
// //                 </button>
// //                 <button
// //                         // className="btn btn-info ml-10"
// //                         className="btn btn-danger ml-2"
// //                         // onClick={() => 
// //                         //     CarregaEmpresa(
// //                         //     dados.ID_EMPRESA,
// //                         //     dados.NOME,
// //                         //     `${dados.ENDERECO} - ${dados.BAIRRO} - ${dados.CIDADE}`,
// //                         //     dados.FONE,
// //                         //     // dados.USU_TIPO_AGENDA // ou a variável que contém o tipo de agenda
// //                         //     // tipoAgenda // ou a variável que contém o tipo de agenda
// //                         //     dados.USU_TIPO_AGENDA 
// //                         //         !== null && dados.USU_TIPO_AGENDA 
// //                         //         !== undefined 
// //                         //             ? dados.USU_TIPO_AGENDA
// //                         //             : 0
// //                         // )}
// //                     >
// //                         <i className="bi bi-trash-fill"></i>
// //                         Excluir
// //                 </button>
// //             </td>
// //         </tr>
// //     )
// // }

// // export default CardCAgendamentos;


// import React from 'react';
// import './agendamentos.css';

// // const CardCAgendamentos = ({ agendamento_descricao, agendamento_data, agendamento_hora }) => {
// const CardCAgendamentos = ({ props }) => {
//         const dataReserva = new Date(`${agendamento_data}T${agendamento_hora}`);
//     const dataAtual = new Date();

//     return (
//         <div className="card">
//             <div className="card-body">
//                 <h5 className="card-title">{agendamento_descricao}</h5>
//                 <p>Data de Reserva: {dataReserva.toLocaleString()}</p>
//                 <p>Data/Hora Atual: {dataAtual.toLocaleString()}</p>
//             </div>
//         </div>
//     );
// };

// export default CardCAgendamentos;

// // import React from 'react';
// // import Swal from 'sweetalert2';
